import { render, staticRenderFns } from "./return.vue?vue&type=template&id=4afcab9b&scoped=true&"
import script from "./return.vue?vue&type=script&lang=ts&"
export * from "./return.vue?vue&type=script&lang=ts&"
import style0 from "./return.vue?vue&type=style&index=0&id=4afcab9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcab9b",
  null
  
)

export default component.exports